import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=8d87bbb4&scoped=true"
import script from "./DataBoard.vue?vue&type=script&lang=js"
export * from "./DataBoard.vue?vue&type=script&lang=js"
import style0 from "./DataBoard.vue?vue&type=style&index=0&id=8d87bbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d87bbb4",
  null
  
)

export default component.exports